import { ReactNode } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

export type HintVariant = 'neutral' | 'info';

const VARIANT_STYLES: Record<HintVariant, { box: string; icon: string }> = {
  neutral: { box: 'border-gray-200 bg-gray-100', icon: 'text-gray-500' },
  info: { box: 'border-blue-200 bg-blue-50', icon: 'text-blue-500' },
};

interface HintBoxProps {
  variant?: HintVariant;
  title?: ReactNode;
  children: ReactNode;
  className?: string;
}

export const HintBox = ({ variant = 'neutral', title, children, className }: HintBoxProps) => {
  const styles = VARIANT_STYLES[variant];
  const box = ['rounded-lg border p-4', styles.box, className].filter(Boolean).join(' ');

  if (title) {
    return (
      <div className={`flex flex-col gap-2 ${box}`}>
        <div className="flex items-center gap-2">
          <FaInfoCircle className={`flex-shrink-0 ${styles.icon}`} size={16} />
          <p className="text-sm font-medium text-gray-900">{title}</p>
        </div>
        {children}
      </div>
    );
  }

  return (
    <div className={`flex items-start gap-3 ${box}`}>
      <FaInfoCircle className={`mt-0.5 flex-shrink-0 ${styles.icon}`} size={16} />
      <div className="text-sm text-gray-700">{children}</div>
    </div>
  );
};
